<template>
  <div class="page-card">
    <el-card>
      <div slot="header" class="header-row">
        <span>打卡审核</span>
        <div>
          <el-select v-model="query.verified" size="small" style="width: 140px;" @change="onFilterChange">
            <el-option label="全部" value="" />
            <el-option label="待审核" :value="0" />
            <el-option label="已通过" :value="1" />
            <el-option label="已驳回" :value="-1" />
          </el-select>
        </div>
      </div>

      <el-alert
        type="info"
        :closable="false"
        show-icon
        style="margin-bottom: 12px;"
        title="审核通过后，系统将自动为提交用户增加积分（默认 10 分，可在「系统管理 - 客服电话」页修改「打卡审核积分」）。每条打卡仅发放一次。"
      />

      <el-table :data="list" border stripe>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column label="图片" width="120">
          <template slot-scope="scope">
            <img v-if="displayImage(scope.row)" :src="displayImage(scope.row)" class="spot-image" />
            <span v-else class="img-empty">无图</span>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题" min-width="180" />
        <el-table-column prop="category" label="分类" width="120" />
        <el-table-column label="提交用户" width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.userName || (scope.row.userId != null ? `ID:${scope.row.userId}` : '-') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="已发积分" width="90">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.auditPointsGranted" type="success" size="mini">是</el-tag>
            <span v-else style="color:#909399;">-</span>
          </template>
        </el-table-column>
        <el-table-column label="审核状态" width="110">
          <template slot-scope="scope">
            <el-tag :type="statusTagType(scope.row.verified)">
              {{ statusText(scope.row.verified) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="提交时间" width="180" />
        <el-table-column label="操作" width="300" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="openDetail(scope.row)">详情</el-button>
            <el-button
              size="mini"
              type="success"
              :disabled="Number(scope.row.verified) > 0"
              @click="audit(scope.row, true)"
            >
              通过
            </el-button>
            <el-button
              size="mini"
              type="danger"
              :disabled="false"
              @click="audit(scope.row, false)"
            >
              驳回
            </el-button>
            <el-button size="mini" type="danger" plain @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pager">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :total="total"
          :current-page.sync="query.page"
          :page-size="query.pageSize"
          @current-change="fetchList"
        />
      </div>

      <el-dialog title="打卡详情" :visible.sync="detailVisible" width="760px">
        <el-descriptions :column="2" border v-if="detailRow">
          <el-descriptions-item label="ID">{{ detailRow.id }}</el-descriptions-item>
          <el-descriptions-item label="打卡点名称">{{ detailRow.title || '-' }}</el-descriptions-item>
          <el-descriptions-item label="分类">{{ detailRow.category || '-' }}</el-descriptions-item>
          <el-descriptions-item label="提交用户">
            {{ detailRow.userName || (detailRow.userId != null ? `ID:${detailRow.userId}` : '-') }}
          </el-descriptions-item>
          <el-descriptions-item label="审核积分已发放">
            {{ detailRow.auditPointsGranted ? '是' : '否' }}
          </el-descriptions-item>
          <el-descriptions-item label="地址信息" :span="2">{{ detailRow.address || '-' }}</el-descriptions-item>
          <el-descriptions-item label="备注信息" :span="2">{{ detailRow.remark || '-' }}</el-descriptions-item>
          <el-descriptions-item label="审核状态">
            <el-tag :type="statusTagType(detailRow.verified)">
              {{ statusText(detailRow.verified) }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="纬度">{{ detailRow.latitude || '-' }}</el-descriptions-item>
          <el-descriptions-item label="经度">{{ detailRow.longitude || '-' }}</el-descriptions-item>
          <el-descriptions-item label="点赞">{{ detailRow.likes || 0 }}</el-descriptions-item>
          <el-descriptions-item label="浏览">{{ detailRow.views || 0 }}</el-descriptions-item>
          <el-descriptions-item label="提交时间" :span="2">{{ detailRow.createdAt || '-' }}</el-descriptions-item>
          <el-descriptions-item label="主图" :span="2">
            <img v-if="displayImage(detailRow)" :src="displayImage(detailRow)" class="detail-main-image" />
            <span v-else>-</span>
          </el-descriptions-item>
          <el-descriptions-item label="相册" :span="2">
            <div class="detail-photo-list" v-if="detailPhotos.length">
              <img v-for="(p, idx) in detailPhotos" :key="idx" :src="safeMediaUrl(p)" class="detail-photo" />
            </div>
            <span v-else>-</span>
          </el-descriptions-item>
        </el-descriptions>
        <span slot="footer">
          <el-button @click="detailVisible = false">关 闭</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import request, { normalizeMediaUrl } from '@/api/request'

export default {
  name: 'CheckinAuditList',
  data() {
    return {
      list: [],
      total: 0,
      detailVisible: false,
      detailRow: null,
      query: {
        verified: '',
        page: 1,
        pageSize: 10
      }
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    /** 与商家管理、资讯等一致：normalizeMediaUrl(u) || u，并兼容 photos 为 JSON 字符串 */
    parsePhotosField(raw) {
      if (raw == null) return []
      if (Array.isArray(raw)) return raw
      if (typeof raw === 'string') {
        const t = raw.trim()
        if (!t) return []
        try {
          const j = JSON.parse(t)
          return Array.isArray(j) ? j : [t]
        } catch (e) {
          return t.split(',').map(s => s.trim().replace(/^["']|["']$/g, '')).filter(Boolean)
        }
      }
      return []
    },
    normalizeCheckinRow(row) {
      if (!row) return row
      const photosRaw = this.parsePhotosField(row.photos)
      const imageNorm = normalizeMediaUrl(row.image) || row.image
      const photosNorm = photosRaw.map(u => normalizeMediaUrl(u) || u).filter(Boolean)
      return {
        ...row,
        image: imageNorm,
        photos: photosNorm
      }
    },
    fetchList() {
      request.get('/checkin', { params: this.query }).then(res => {
        const data = (res.data || res) || {}
        const items = data.items || []
        this.list = items.map(r => this.normalizeCheckinRow(r))
        this.total = Number(data.total || 0)
      })
    },
    statusText(verified) {
      const v = Number(verified || 0)
      if (v > 0) return '已通过'
      if (v < 0) return '已驳回'
      return '待审核'
    },
    statusTagType(verified) {
      const v = Number(verified || 0)
      if (v > 0) return 'success'
      if (v < 0) return 'danger'
      return 'warning'
    },
    safeMediaUrl(v) {
      const raw = typeof v === 'string' ? v.trim() : v
      if (!raw) return ''
      if (/^(wxfile:|file:)/i.test(raw)) return ''
      const u = normalizeMediaUrl(raw) || raw
      if (/^(wxfile:|file:)/i.test(u)) return ''
      return u
    },
    displayImage(row) {
      if (!row) return ''
      const main = (row.image && String(row.image).trim()) || ''
      if (main && !/^(wxfile:|file:)/i.test(main)) return main
      const photos = Array.isArray(row.photos) ? row.photos : []
      for (let i = 0; i < photos.length; i += 1) {
        const u = photos[i] && String(photos[i]).trim()
        if (u && !/^(wxfile:|file:)/i.test(u)) return u
      }
      return ''
    },
    onFilterChange() {
      this.query.page = 1
      this.fetchList()
    },
    openDetail(row) {
      this.detailRow = row ? { ...row } : null
      this.detailVisible = true
    },
    audit(row, approved) {
      const actionText = approved ? '通过' : '驳回'
      this.$confirm(`确认${actionText}该打卡内容吗？`, '提示', { type: 'warning' }).then(() => {
        request.put(`/checkin/${row.id}/audit`, { approved }).then(res => {
          const pack = res.data != null ? res.data : res
          let msg = '审核已更新'
          if (approved && pack && pack.pointsGranted) {
            msg = `审核已通过，已为用户发放 ${pack.pointsAdded || 0} 积分`
          }
          this.$message.success(msg)
          this.fetchList()
        })
      })
    }
    ,
    remove(row) {
      if (!row || !row.id) return
      this.$confirm('确认删除这条打卡记录吗？删除后不可恢复。', '提示', { type: 'warning' }).then(() => {
        request.delete(`/checkin/${row.id}`).then(() => {
          this.$message.success('删除成功')
          this.fetchList()
        })
      })
    }
  },
  computed: {
    detailPhotos() {
      if (!this.detailRow || !Array.isArray(this.detailRow.photos)) return []
      return this.detailRow.photos.filter(p => p && String(p).trim())
    }
  }
}
</script>

<style scoped>
.header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.spot-image {
  width: 90px;
  height: 56px;
  object-fit: contain;
  background: #f5f7fa;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.img-empty {
  color: #909399;
  font-size: 12px;
}

.pager {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
}

.detail-main-image {
  width: 240px;
  height: 140px;
  object-fit: contain;
  background: #f5f7fa;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.detail-photo-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.detail-photo {
  width: 120px;
  height: 80px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}
</style>
